/**
 * How a line of the control plane's own trail is coloured.
 *
 * The word itself is never translated and never replaced: `action` and
 * `outcome` are the server's vocabulary — `tenant.reconcile`, `catalog.put`,
 * `rollout.move`; `success`, `accepted`, `not_accepted`, `moved` — and the set
 * grows there. A console holding its own copy of it would go quiet on the entry
 * that mattered, on the day a new one appeared. So the screen prints what
 * arrived and this decides only what colour to print it in.
 *
 * An outcome neither side knows is neutral rather than a fault: not knowing how
 * something came out is not the same as knowing it went wrong.
 */

import type { Tone } from '../../ui/StatusBadge';

const TRAIL_TONE: Record<string, Tone> = {
  success: 'ok',
  accepted: 'ok',
  moved: 'ok',
  done: 'ok',
  applied: 'ok',
  not_accepted: 'warn',
  waiting: 'warn',
  pending: 'neutral',
  applying: 'info',
  halted: 'neutral',
  failed: 'deny',
};

export function trailTone(outcome: string): Tone {
  return TRAIL_TONE[outcome] ?? 'neutral';
}
